const FilterAble = function (types, syncWithServer = false) {
    return {
        data: function () {
            return {
                filters: {},
                _filters: {},
                settings: {},
                loading: false,
                syncWithServer: syncWithServer,
                serverItemsLength: null
            };
        },
        props: {
            search: {
                type: Object,
                default: () => {
                    return {};
                },
            },
            hideSearch: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
        watch: {
            search: {
                deep: true,
                handler() {
                    this.getData();
                },
            },
            hideSearch: {
                deep: true,
                handler() {
                    this.getData();
                },
            },
        },
        methods: {
            pagination(pagination) {
                this.filters.page = pagination.page;
                this.filters.per_page = pagination.itemsPerPage;
                this.filters.orderBy = pagination.sortBy.join(",") || "id";
                this.filters.reverse = pagination.sortDesc.length && pagination.sortDesc[0] ? 0 : 1;
                this.updateQuery();
                this.getData();
            },
            freeSearch(search, filters = []) {
                this.$set(this.filters, "like", search + ":" + filters.join(","));
                this.updateQuery();
                this.getData();

            },
            changePage(page) {
                this.filters.page = page;
                this.updateQuery();
                this.getData();
            },
            order({orderBy, reverse}) {
                this.filters.orderBy = orderBy;
                this.filters.reverse = reverse;
                this.filters.page = 1;
                this.updateQuery();
                this.getData();
            },
            updateFilters() {
                this._filters = Object.assign({}, this.filters, this.$route.query, this.hideSearch);
            },
            async filter({filterName, filterValue}) {
                this.filters[filterName] = filterValue;
                this.filters.page = 1;
                await this.updateQuery();
                await this.getData();
            },
            async getData() {
                this.loading = true;
                await this.updateQuery();
                let response;
                if (this.$notfication && this.$notfication.loading) {
                    response = await this.$notfication.loading(this.getDataFromServer());
                } else {
                    response = await this.getDataFromServer();
                }
                this.loading = false;
                if (response.total) {
                    this.serverItemsLength = response.total;
                }
                return response;
            },
            getDataFromServer() {
                return this.$store.dispatch(types.FETCH, Object.assign({}, this.search, this._filters, this.hideSearch)).then((response) => {
                    if (!Array.isArray(response)) {
                        this.settings = response;
                    }
                    return response;
                });
            },
            async updateQuery() {
                const query = Object.assign({}, this.search);
                Object.keys(query).forEach((key) => (query[key] == null || query[key] === "" || query[key] == undefined) && delete query[key]);
                if (Object.keys(query).length || Object.keys(this.$route.query).length) {
                    await this.$router.push({
                        query,
                    });
                }
                this.updateFilters();
            },
        },
        created: function () {
            this._filters = Object.assign({}, this.filters, this.$route.query, this.hideSearch);
            this.getData();
        },
    };
};
export default FilterAble;
